module.exports = __webpack_public_path__ + "static/media/empty-img.358bba1b.png";